<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header User-Form">
        <h5 class="modal-title">User Form</h5>
        <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form>

          <!-- Username -->
          <app-input 
            [customClass]="'text-black'"
            [inputName]="'username'"
            [inputType]="'text'"
            [inputId]="'usernameId'"
            [inputValue]="userForm.username"
            [inputLabel]="'User Name'"
            [inputPlaceholder]="'Enter username'"
            (inputValueEmit)="userForm.username = $event"
            [isRequired]="true">
          </app-input>

          <!-- Password -->
          <app-input 
            [customClass]="'text-black'"
            [inputName]="'password'"
            [inputType]="'password'"
            [inputId]="'passwordId'"
            [inputValue]="userForm.password"
            [inputLabel]="'Password'"
            [inputPlaceholder]="'Enter password'"
            (inputValueEmit)="userForm.password = $event"
            [isRequired]="true">
          </app-input>

          <!-- GST No -->
          <app-input 
            [customClass]="'text-black'"
            [inputName]="'ipAddress'"
            [inputType]="'text'"
            [inputId]="'ipAddress'"
            [inputValue]="userForm.ipAddress"
            [inputLabel]="'Ip Address'"
            [inputPlaceholder]="'Enter Ip Address'"
            (inputValueEmit)="userForm.ipAddress = $event"
            [isRequired]="true">
          </app-input>

        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <app-button 
        class="btns"
          [customClass]="'danger'"
          [buttonLabel]="'Close'"
          (click)="activeModal.dismiss()">
        </app-button>

        <app-button
        class="btns"
          [customClass]="'primary'"
          [buttonLabel]="'Save'"
          (click)="save()">
        </app-button>
      </div>

    </div>
  </div>
</div>